export let deleteItem = "CtVN4";
export default {deleteItem};